var _path, _path2, _circle, _circle2, _circle3, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _circle4, _rect49, _rect50, _path3, _path4, _circle5, _path5, _g2, _circle6, _circle7, _circle8, _g3, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _circle9, _rect99, _rect100, _path6, _path7, _path8, _circle10, _g4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoNoel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1520,
    height: 1242,
    viewBox: "0 0 1520 1242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.679 1091.5C452.779 1107.1 421.579 1118.37 389.079 1125.3C356.579 1132.23 323.429 1135.7 289.629 1135.7C253.662 1135.7 220.512 1130.07 190.179 1118.8C159.845 1107.53 133.629 1091.5 111.529 1070.7C89.4285 1049.47 72.0952 1023.9 59.5285 994C47.3952 964.1 41.3285 930.733 41.3285 893.9C41.3285 857.067 47.3952 823.7 59.5285 793.8C72.0952 763.9 89.4285 738.55 111.529 717.75C133.629 696.517 159.845 680.267 190.179 669C220.512 657.733 253.662 652.1 289.629 652.1C326.462 652.1 360.262 656.65 391.029 665.75C422.229 674.417 449.529 689.583 472.929 711.25L401.429 789.25C387.562 774.95 371.962 764.117 354.629 756.75C337.295 749.383 315.629 745.7 289.629 745.7C267.962 745.7 248.245 749.383 230.479 756.75C213.145 764.117 198.195 774.517 185.629 787.95C173.062 800.95 163.312 816.55 156.379 834.75C149.879 852.95 146.629 872.667 146.629 893.9C146.629 915.567 149.879 935.5 156.379 953.7C163.312 971.467 173.062 987.067 185.629 1000.5C198.195 1013.5 213.145 1023.68 230.479 1031.05C248.245 1038.42 267.962 1042.1 289.629 1042.1C311.729 1042.1 330.795 1039.72 346.829 1034.95C362.862 1029.75 375.645 1024.55 385.179 1019.35V944.6H302.629V851H482.679V1091.5ZM757.837 1084.35H756.537C745.703 1101.25 731.187 1113.38 712.987 1120.75C695.22 1128.12 676.37 1131.8 656.437 1131.8C641.703 1131.8 627.403 1129.63 613.537 1125.3C600.103 1121.4 588.187 1115.33 577.787 1107.1C567.387 1098.87 559.153 1088.68 553.087 1076.55C547.02 1064.42 543.987 1050.33 543.987 1034.3C543.987 1016.1 547.237 1000.72 553.737 988.15C560.67 975.583 569.77 965.183 581.037 956.95C592.737 948.717 605.953 942.433 620.687 938.1C635.42 933.333 650.587 929.867 666.187 927.7C682.22 925.533 698.037 924.233 713.637 923.8C729.67 923.367 744.403 923.15 757.837 923.15C757.837 905.817 751.553 892.167 738.987 882.2C726.853 871.8 712.337 866.6 695.437 866.6C679.403 866.6 664.67 870.067 651.237 877C638.237 883.5 626.537 892.6 616.137 904.3L564.137 851C582.337 834.1 603.57 821.533 627.837 813.3C652.103 804.633 677.237 800.3 703.237 800.3C731.837 800.3 755.237 803.983 773.437 811.35C792.07 818.283 806.803 828.683 817.637 842.55C828.903 856.417 836.703 873.533 841.037 893.9C845.37 913.833 847.537 937.017 847.537 963.45V1124H757.837V1084.35ZM733.787 985.55C726.42 985.55 717.103 985.983 705.837 986.85C695.003 987.283 684.387 989.017 673.987 992.05C664.02 995.083 655.353 999.633 647.987 1005.7C641.053 1011.77 637.587 1020.22 637.587 1031.05C637.587 1042.75 642.57 1051.42 652.537 1057.05C662.503 1062.68 672.903 1065.5 683.737 1065.5C693.27 1065.5 702.37 1064.2 711.037 1061.6C720.137 1059 728.153 1055.32 735.087 1050.55C742.02 1045.78 747.437 1039.72 751.337 1032.35C755.67 1024.98 757.837 1016.32 757.837 1006.35V985.55H733.787ZM908.708 808.1H1006.21V858.8H1007.51C1017.91 839.3 1030.26 824.783 1044.56 815.25C1058.86 805.283 1076.84 800.3 1098.51 800.3C1104.14 800.3 1109.77 800.517 1115.41 800.95C1121.04 801.383 1126.24 802.25 1131.01 803.55V892.6C1124.07 890.433 1117.14 888.917 1110.21 888.05C1103.71 886.75 1096.77 886.1 1089.41 886.1C1070.77 886.1 1056.04 888.7 1045.21 893.9C1034.37 899.1 1025.92 906.467 1019.86 916C1014.22 925.1 1010.54 936.15 1008.81 949.15C1007.07 962.15 1006.21 976.45 1006.21 992.05V1124H908.708V808.1ZM1460.98 1069.4C1445.38 1089.33 1425.66 1104.72 1401.83 1115.55C1378 1126.38 1353.3 1131.8 1327.73 1131.8C1303.46 1131.8 1280.5 1127.9 1258.83 1120.1C1237.6 1112.3 1218.96 1101.25 1202.93 1086.95C1187.33 1072.22 1174.98 1054.67 1165.88 1034.3C1156.78 1013.93 1152.23 991.183 1152.23 966.05C1152.23 940.917 1156.78 918.167 1165.88 897.8C1174.98 877.433 1187.33 860.1 1202.93 845.8C1218.96 831.067 1237.6 819.8 1258.83 812C1280.5 804.2 1303.46 800.3 1327.73 800.3C1350.26 800.3 1370.63 804.2 1388.83 812C1407.46 819.8 1423.06 831.067 1435.63 845.8C1448.63 860.1 1458.6 877.433 1465.53 897.8C1472.46 918.167 1475.93 940.917 1475.93 966.05V996.6H1249.73C1253.63 1015.23 1262.08 1030.18 1275.08 1041.45C1288.08 1052.28 1304.11 1057.7 1323.18 1057.7C1339.21 1057.7 1352.65 1054.23 1363.48 1047.3C1374.75 1039.93 1384.5 1030.62 1392.73 1019.35L1460.98 1069.4ZM1378.43 930.3C1378.86 913.833 1373.45 899.75 1362.18 888.05C1350.91 876.35 1336.4 870.5 1318.63 870.5C1307.8 870.5 1298.26 872.233 1290.03 875.7C1281.8 879.167 1274.65 883.717 1268.58 889.35C1262.95 894.55 1258.4 900.833 1254.93 908.2C1251.9 915.133 1250.16 922.5 1249.73 930.3H1378.43Z",
    fill: "url(#paint0_linear_608_1198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.5 87.8H308.9V548H207.5V87.8ZM388.784 232.1H482.384V275H483.684C486.717 268.933 491.051 262.867 496.684 256.8C502.317 250.733 509.034 245.317 516.834 240.55C524.634 235.783 533.517 231.883 543.484 228.85C553.451 225.817 564.284 224.3 575.984 224.3C600.684 224.3 620.617 228.2 635.784 236C650.951 243.367 662.651 253.767 670.884 267.2C679.551 280.633 685.401 296.45 688.434 314.65C691.467 332.85 692.984 352.567 692.984 373.8V548H595.484V393.3C595.484 384.2 595.051 374.883 594.184 365.35C593.751 355.383 591.801 346.283 588.334 338.05C585.301 329.817 580.317 323.1 573.384 317.9C566.884 312.7 557.351 310.1 544.784 310.1C532.217 310.1 522.034 312.483 514.234 317.25C506.434 321.583 500.367 327.65 496.034 335.45C492.134 342.817 489.534 351.267 488.234 360.8C486.934 370.333 486.284 380.3 486.284 390.7V548H388.784V232.1ZM795.826 310.1H731.476V232.1H795.826V176.2C795.826 158.867 797.343 142.617 800.376 127.45C803.41 111.85 809.26 98.2 817.926 86.5C826.593 74.8 838.943 65.7 854.976 59.2C871.443 52.2667 892.893 48.8 919.326 48.8C929.293 48.8 939.043 49.2333 948.576 50.1C958.11 50.9666 967.426 52.4833 976.526 54.65L971.976 137.2C966.343 135.033 961.143 133.517 956.376 132.65C951.61 131.35 946.193 130.7 940.126 130.7C924.526 130.7 912.826 134.167 905.026 141.1C897.226 147.6 893.326 161.25 893.326 182.05V232.1H965.476V310.1H893.326V548H795.826V310.1Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 396,
    r: 180,
    fill: "#4E4B4D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 396,
    r: 164,
    fill: "#262A31"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 390,
    r: 96,
    fill: "#393A3F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_608_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.77 432.055C1134.31 432.075 1134 432.301 1134 432.783V454.294C1134 454.669 1134.26 455.008 1134.66 455.008H1171.41C1171.74 455.008 1172.01 454.977 1172.16 454.521C1172.16 454.521 1175.89 442.341 1175.95 442.121C1176.09 441.661 1176 441.427 1175.62 441.177C1163.65 433.162 1145.75 432 1137.63 432C1136.46 432 1135.5 432.024 1134.78 432.054",
    fill: "#716E6F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 232,
    width: 5,
    height: 44,
    fill: "#E2D752"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 253.718,
    width: 5,
    height: 44,
    transform: "rotate(-32.9276 1070 253.718)",
    fill: "#E2D752"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 459.307,
    width: 5,
    height: 44,
    transform: "rotate(-59.472 1259 459.307)",
    fill: "#E2D752"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1013,
    y: 314.257,
    width: 5,
    height: 44,
    transform: "rotate(-58.3662 1013 314.257)",
    fill: "#E2D752"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 501.652,
    width: 5,
    height: 44,
    transform: "rotate(-32.0287 1212 501.652)",
    fill: "#E2D752"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1091.67,
    y: 498,
    width: 5,
    height: 44,
    transform: "rotate(29.5072 1091.67 498)",
    fill: "#E2D752"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1047.42,
    y: 454,
    width: 5,
    height: 44,
    transform: "rotate(58.261 1047.42 454)",
    fill: "#E2D752"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1234.96,
    y: 251,
    width: 5,
    height: 44,
    transform: "rotate(31.4487 1234.96 251)",
    fill: "#E2D752"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1294.45,
    y: 310,
    width: 5,
    height: 44,
    transform: "rotate(58.3241 1294.45 310)",
    fill: "#E2D752"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1304.48,
    y: 333,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(70.4633 1304.48 333)",
    fill: "#E2D752"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1312.26,
    y: 353,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(77.1294 1312.26 353)",
    fill: "#E2D752"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.77,
    y: 374,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(84.9766 1314.77 374)",
    fill: "#E2D752"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.94,
    y: 415.16,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(95.1942 1314.94 415.16)",
    fill: "#E2D752"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1311.71,
    y: 436.42,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(106.088 1311.71 436.42)",
    fill: "#E2D752"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1304.5,
    y: 456.977,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(114.719 1304.5 456.977)",
    fill: "#E2D752"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1283.65,
    y: 493.191,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(129.548 1283.65 493.191)",
    fill: "#E2D752"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1269.97,
    y: 509.184,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(136.076 1269.97 509.184)",
    fill: "#E2D752"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1253.95,
    y: 523.046,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(142.97 1253.95 523.046)",
    fill: "#E2D752"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1217.42,
    y: 544.634,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(161.562 1217.42 544.634)",
    fill: "#E2D752"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1196.88,
    y: 552.171,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(169.362 1196.88 552.171)",
    fill: "#E2D752"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1176.1,
    y: 555.832,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(177.292 1176.1 555.832)",
    fill: "#E2D752"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1134.2,
    y: 555.927,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-173.582 1134.2 555.927)",
    fill: "#E2D752"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1112.88,
    y: 552.272,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-161.7 1112.88 552.272)",
    fill: "#E2D752"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1093.02,
    y: 545.032,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-157.457 1093.02 545.032)",
    fill: "#E2D752"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1057.59,
    y: 523.416,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-143.783 1057.59 523.416)",
    fill: "#E2D752"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1039.3,
    y: 510.139,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-130.984 1039.3 510.139)",
    fill: "#E2D752"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1025.76,
    y: 494.578,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-127.263 1025.76 494.578)",
    fill: "#E2D752"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1005.81,
    y: 457.579,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-114.19 1005.81 457.579)",
    fill: "#E2D752"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 998.513,
    y: 438.099,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-105.04 998.513 438.099)",
    fill: "#E2D752"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 994.171,
    y: 416.038,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-94.9782 994.171 416.038)",
    fill: "#E2D752"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 994,
    y: 374.974,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-88.1172 994 374.974)",
    fill: "#E2D752"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 352.876,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-71.7103 998 352.876)",
    fill: "#E2D752"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1005,
    y: 332.792,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-65.0906 1005 332.792)",
    fill: "#E2D752"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1027,
    y: 297.479,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-48.4517 1027 297.479)",
    fill: "#E2D752"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1040.29,
    y: 281.109,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-46.2095 1040.29 281.109)",
    fill: "#E2D752"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 267.21,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-37.772 1056 267.21)",
    fill: "#E2D752"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 246.739,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-21.9721 1093 246.739)",
    fill: "#E2D752"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1113,
    y: 239.361,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-10.5388 1113 239.361)",
    fill: "#E2D752"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1134,
    y: 234.171,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-4.9619 1134 234.171)",
    fill: "#E2D752"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1175.99,
    y: 234,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(9.61784 1175.99 234)",
    fill: "#E2D752"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1197.63,
    y: 238,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(18.6463 1197.63 238)",
    fill: "#E2D752"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1216.66,
    y: 245.306,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(23.8044 1216.66 245.306)",
    fill: "#E2D752"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1252.7,
    y: 266,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(38.0372 1252.7 266)",
    fill: "#E2D752"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1269.43,
    y: 280,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(46.9326 1269.43 280)",
    fill: "#E2D752"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1282.79,
    y: 297,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(56.0556 1282.79 297)",
    fill: "#E2D752"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 516,
    width: 5,
    height: 44,
    fill: "#E2D752"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1275,
    y: 398,
    width: 5,
    height: 44,
    transform: "rotate(-90 1275 398)",
    fill: "#E2D752"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 991,
    y: 398,
    width: 5,
    height: 44,
    transform: "rotate(-90 991 398)",
    fill: "#E2D752"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1154.5,
    cy: 395.5,
    r: 165.5,
    stroke: "#4E4B4D",
    strokeWidth: 10
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1178.01,
    y: 420.417,
    width: 119.76,
    height: 20.4465,
    transform: "rotate(-147.247 1178.01 420.417)",
    fill: "#B0A83E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1122.86,
    y: 409.73,
    width: 155.882,
    height: 15.158,
    transform: "rotate(-37.5671 1122.86 409.73)",
    fill: "#E2D752"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.22 315.848L1255.65 326.696L1246.32 314.725L1257.22 315.848Z",
    fill: "#E2D752"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.96 343.207L1088.39 338.425L1077.31 355.594L1076.96 343.207Z",
    fill: "#B0A83E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1267.5,
    cy: 508.5,
    r: 67.5,
    fill: "#01518B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.27 540L1221.88 490.352L1216.91 489.727V483.125H1238.87V489.727L1233.71 490.508L1245.12 524.453L1246.02 527.734H1246.25L1247.19 524.531L1258.63 490.508L1252.7 489.727V483.125H1273.75V489.727L1268.67 490.352L1251.25 540H1240.27ZM1278.36 540V532.852L1296.84 512.891C1298.74 510.755 1300.23 508.893 1301.33 507.305C1302.42 505.716 1303.2 504.271 1303.67 502.969C1304.14 501.641 1304.38 500.326 1304.38 499.023C1304.38 496.706 1303.71 494.753 1302.38 493.164C1301.05 491.549 1299.1 490.742 1296.52 490.742C1293.82 490.742 1291.74 491.628 1290.31 493.398C1288.91 495.143 1288.2 497.565 1288.2 500.664H1277.62L1277.54 500.43C1277.46 497.018 1278.19 493.945 1279.73 491.211C1281.26 488.477 1283.48 486.315 1286.37 484.727C1289.28 483.112 1292.72 482.305 1296.68 482.305C1300.53 482.305 1303.84 483.008 1306.6 484.414C1309.39 485.794 1311.52 487.721 1313.01 490.195C1314.52 492.669 1315.27 495.534 1315.27 498.789C1315.27 501.029 1314.87 503.151 1314.06 505.156C1313.26 507.161 1311.99 509.271 1310.27 511.484C1308.58 513.672 1306.42 516.172 1303.79 518.984L1292.19 531.484L1292.27 531.68H1307.77L1308.36 526.094H1316.88V540H1278.36Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_608_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1269.01 137.673C1266.56 137.216 1264.29 136.865 1261.97 136.483C1261.03 136.286 1260.13 136.017 1259.18 135.839C1160.87 117.503 1083.66 149.71 1075.56 193.141C1067.45 236.572 1130.87 244.149 1196.02 256.3C1239.68 264.445 1271.2 270.324 1294.14 273.729L1294.32 274.637L1325.8 433.095L1345.46 436.763C1345.46 436.763 1354.43 407.359 1368.13 369.783C1388.96 312.634 1411.87 164.321 1269.01 137.673Z",
    fill: "#DD2E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.46 484.081C1348.18 488.132 1369.07 473.811 1373.12 452.094C1377.17 430.377 1362.85 409.488 1341.13 405.437C1319.41 401.387 1298.53 415.708 1294.47 437.425C1290.42 459.142 1304.74 480.03 1326.46 484.081Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.48 272.141C1333.45 282.994 1323 290.159 1312.15 288.134L1066.39 242.294C1055.53 240.269 1048.37 229.818 1050.39 218.965L1052.23 209.135C1054.25 198.282 1064.7 191.117 1075.56 193.141L1321.32 238.982C1332.17 241.006 1339.33 251.457 1337.31 262.31L1335.48 272.141Z",
    fill: "#F1F2F2"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 395.614,
    r: 180,
    fill: "#4E4B4D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 395.614,
    r: 164,
    fill: "#262A31"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 389.614,
    r: 96,
    fill: "#393A3F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_608_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.77 431.668C1134.31 431.689 1134 431.914 1134 432.397V453.907C1134 454.282 1134.26 454.622 1134.66 454.622H1171.41C1171.74 454.622 1172.01 454.59 1172.16 454.135C1172.16 454.135 1175.89 441.955 1175.95 441.735C1176.09 441.275 1176 441.041 1175.62 440.791C1163.65 432.776 1145.75 431.613 1137.63 431.613C1136.46 431.613 1135.5 431.638 1134.78 431.668",
    fill: "#716E6F"
  }))), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 231.614,
    width: 5,
    height: 44,
    fill: "#E2D752"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 253.331,
    width: 5,
    height: 44,
    transform: "rotate(-32.9276 1070 253.331)",
    fill: "#E2D752"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 458.921,
    width: 5,
    height: 44,
    transform: "rotate(-59.472 1259 458.921)",
    fill: "#E2D752"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 1013,
    y: 313.871,
    width: 5,
    height: 44,
    transform: "rotate(-58.3662 1013 313.871)",
    fill: "#E2D752"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 501.265,
    width: 5,
    height: 44,
    transform: "rotate(-32.0287 1212 501.265)",
    fill: "#E2D752"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1091.67,
    y: 497.614,
    width: 5,
    height: 44,
    transform: "rotate(29.5072 1091.67 497.614)",
    fill: "#E2D752"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1047.42,
    y: 453.614,
    width: 5,
    height: 44,
    transform: "rotate(58.261 1047.42 453.614)",
    fill: "#E2D752"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1234.96,
    y: 250.614,
    width: 5,
    height: 44,
    transform: "rotate(31.4487 1234.96 250.614)",
    fill: "#E2D752"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1294.45,
    y: 309.614,
    width: 5,
    height: 44,
    transform: "rotate(58.3241 1294.45 309.614)",
    fill: "#E2D752"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1304.48,
    y: 332.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(70.4633 1304.48 332.614)",
    fill: "#E2D752"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1312.26,
    y: 352.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(77.1294 1312.26 352.614)",
    fill: "#E2D752"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.77,
    y: 373.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(84.9766 1314.77 373.614)",
    fill: "#E2D752"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.94,
    y: 414.774,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(95.1942 1314.94 414.774)",
    fill: "#E2D752"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1311.71,
    y: 436.034,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(106.088 1311.71 436.034)",
    fill: "#E2D752"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1304.5,
    y: 456.591,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(114.719 1304.5 456.591)",
    fill: "#E2D752"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 1283.65,
    y: 492.805,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(129.548 1283.65 492.805)",
    fill: "#E2D752"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 1269.97,
    y: 508.798,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(136.076 1269.97 508.798)",
    fill: "#E2D752"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 1253.95,
    y: 522.66,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(142.97 1253.95 522.66)",
    fill: "#E2D752"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 1217.42,
    y: 544.247,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(161.562 1217.42 544.247)",
    fill: "#E2D752"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 1196.88,
    y: 551.785,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(169.362 1196.88 551.785)",
    fill: "#E2D752"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1176.1,
    y: 555.445,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(177.292 1176.1 555.445)",
    fill: "#E2D752"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1134.2,
    y: 555.541,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-173.582 1134.2 555.541)",
    fill: "#E2D752"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1112.88,
    y: 551.886,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-161.7 1112.88 551.886)",
    fill: "#E2D752"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1093.02,
    y: 544.646,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-157.457 1093.02 544.646)",
    fill: "#E2D752"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1057.59,
    y: 523.029,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-143.783 1057.59 523.029)",
    fill: "#E2D752"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 1039.3,
    y: 509.753,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-130.984 1039.3 509.753)",
    fill: "#E2D752"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 1025.76,
    y: 494.192,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-127.263 1025.76 494.192)",
    fill: "#E2D752"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 1005.81,
    y: 457.192,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-114.19 1005.81 457.192)",
    fill: "#E2D752"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 998.513,
    y: 437.713,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-105.04 998.513 437.713)",
    fill: "#E2D752"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 994.171,
    y: 415.652,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-94.9782 994.171 415.652)",
    fill: "#E2D752"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 994,
    y: 374.588,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-88.1172 994 374.588)",
    fill: "#E2D752"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 352.489,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-71.7103 998 352.489)",
    fill: "#E2D752"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 1005,
    y: 332.405,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-65.0906 1005 332.405)",
    fill: "#E2D752"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 1027,
    y: 297.092,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-48.4517 1027 297.092)",
    fill: "#E2D752"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 1040.29,
    y: 280.723,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-46.2095 1040.29 280.723)",
    fill: "#E2D752"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 1056,
    y: 266.824,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-37.772 1056 266.824)",
    fill: "#E2D752"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 246.353,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-21.9721 1093 246.353)",
    fill: "#E2D752"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 1113,
    y: 238.975,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-10.5388 1113 238.975)",
    fill: "#E2D752"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 1134,
    y: 233.785,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-4.9619 1134 233.785)",
    fill: "#E2D752"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 1175.99,
    y: 233.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(9.61784 1175.99 233.614)",
    fill: "#E2D752"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 1197.63,
    y: 237.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(18.6463 1197.63 237.614)",
    fill: "#E2D752"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 1216.66,
    y: 244.92,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(23.8044 1216.66 244.92)",
    fill: "#E2D752"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 1252.7,
    y: 265.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(38.0372 1252.7 265.614)",
    fill: "#E2D752"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 1269.43,
    y: 279.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(46.9326 1269.43 279.614)",
    fill: "#E2D752"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 1282.79,
    y: 296.614,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(56.0556 1282.79 296.614)",
    fill: "#E2D752"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 515.614,
    width: 5,
    height: 44,
    fill: "#E2D752"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 1275,
    y: 397.614,
    width: 5,
    height: 44,
    transform: "rotate(-90 1275 397.614)",
    fill: "#E2D752"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 991,
    y: 397.614,
    width: 5,
    height: 44,
    transform: "rotate(-90 991 397.614)",
    fill: "#E2D752"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1154.5,
    cy: 395.114,
    r: 165.5,
    stroke: "#4E4B4D",
    strokeWidth: 10
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 1178.01,
    y: 420.03,
    width: 119.76,
    height: 20.4465,
    transform: "rotate(-147.247 1178.01 420.03)",
    fill: "#B0A83E"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 1122.86,
    y: 409.344,
    width: 155.882,
    height: 15.158,
    transform: "rotate(-37.5671 1122.86 409.344)",
    fill: "#E2D752"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.22 315.462L1255.65 326.31L1246.32 314.339L1257.22 315.462Z",
    fill: "#E2D752"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.96 342.82L1088.39 338.039L1077.31 355.208L1076.96 342.82Z",
    fill: "#B0A83E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.48 272.141C1333.45 282.994 1323 290.159 1312.15 288.134L1066.39 242.294C1055.53 240.269 1048.37 229.818 1050.39 218.965L1052.23 209.135C1054.25 198.282 1064.7 191.117 1075.56 193.141L1321.32 238.982C1332.17 241.006 1339.33 251.457 1337.31 262.31L1335.48 272.141Z",
    fill: "#F1F2F2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1267.5,
    cy: 508.114,
    r: 67.5,
    fill: "#01518B"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_608_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.78 535.242V481.989L1284.19 468.575C1284.19 468.575 1286.15 466.611 1284.19 464.644C1282.22 462.68 1280.26 464.644 1280.26 464.644L1270.78 474.13V461.392C1270.78 461.392 1270.78 458.614 1268 458.614C1265.22 458.614 1265.22 461.392 1265.22 461.392V474.13L1255.74 464.644C1255.74 464.644 1253.77 462.68 1251.81 464.644C1249.85 466.611 1251.81 468.575 1251.81 468.575L1265.22 481.989V535.242L1251.81 548.653C1251.81 548.653 1249.85 550.617 1251.81 552.58C1253.77 554.544 1255.74 552.58 1255.74 552.58L1265.22 543.097V555.836C1265.22 555.836 1265.22 558.614 1268 558.614C1270.78 558.614 1270.78 555.836 1270.78 555.836V543.097L1280.26 552.58C1280.26 552.58 1282.22 554.544 1284.19 552.58C1286.15 550.617 1284.19 548.653 1284.19 548.653L1270.78 535.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.17 516.575C1313.45 513.892 1310.77 514.611 1310.77 514.611L1292.45 519.519L1246.33 492.892L1241.42 474.572C1241.42 474.572 1240.7 471.889 1238.02 472.608C1235.33 473.328 1236.06 476.011 1236.06 476.011L1239.53 488.967L1228.49 482.594C1228.49 482.594 1226.09 481.205 1224.7 483.611C1223.31 486.017 1225.72 487.405 1225.72 487.405L1236.75 493.775L1223.79 497.244C1223.79 497.244 1221.11 497.964 1221.83 500.647C1222.55 503.333 1225.23 502.614 1225.23 502.614L1243.55 497.705L1289.67 524.333L1294.58 542.655C1294.58 542.655 1295.3 545.339 1297.98 544.619C1300.67 543.897 1299.95 541.217 1299.95 541.217L1296.48 528.261L1307.51 534.63C1307.51 534.63 1309.92 536.019 1311.31 533.617C1312.69 531.208 1310.29 529.819 1310.29 529.819L1299.26 523.45L1312.21 519.98C1312.21 519.978 1314.89 519.258 1314.17 516.575V516.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.21 497.244L1299.25 493.772L1310.29 487.403C1310.29 487.403 1312.69 486.011 1311.31 483.605C1309.91 481.197 1307.51 482.589 1307.51 482.589L1296.48 488.955L1299.95 476.003C1299.95 476.003 1300.67 473.319 1297.98 472.6C1295.3 471.88 1294.58 474.564 1294.58 474.564L1289.67 492.883L1243.55 519.519L1225.23 514.608C1225.23 514.608 1222.55 513.889 1221.83 516.572C1221.11 519.258 1223.79 519.975 1223.79 519.975L1236.75 523.444L1225.72 529.814C1225.72 529.814 1223.31 531.205 1224.7 533.611C1226.09 536.014 1228.49 534.625 1228.49 534.625L1239.53 528.255L1236.06 541.208C1236.06 541.208 1235.34 543.894 1238.02 544.611C1240.71 545.333 1241.43 542.65 1241.43 542.65L1246.34 524.325L1292.46 497.7L1310.78 502.611C1310.78 502.611 1313.46 503.33 1314.18 500.647C1314.89 497.961 1312.21 497.244 1312.21 497.244V497.244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_608_1198",
    x1: 0.0449297,
    y1: 1280.9,
    x2: 1517.77,
    y2: 1280.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C2270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    stopColor: "#AA147E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8146,
    stopColor: "#E41D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41D25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_608_1198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 23,
    fill: "white",
    transform: "translate(1134 432)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_608_1198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "white",
    transform: "translate(1072.4 101) rotate(10.5657)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_608_1198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 23,
    fill: "white",
    transform: "translate(1134 431.614)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_608_1198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(1218 458.614)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoel);
export default __webpack_public_path__ + "static/media/Logo_Noel.4470e77719fcee5eb0697ac8225edcf8.svg";
export { ForwardRef as ReactComponent };